import React, {useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import CountersCard from '../../../ui/CountersCard';
import Breadcrumbs from "../../../ui/Breadcrumbs";
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import {
  counterOrganizationsQuery,
  counterResourcesQuery,
  counterPersonsQuery,
  counterUsersQuery,
  counterProgramsQuery,
  counterReferencesQuery,
  counterSitesQuery,
  counterSkillsQuery
} from "./reducer";

const items = [
  {
    label: "Управление ООП",
    link: "#"
  },
  {
    label: "Ресурсы",
    link: "#"
  },
];

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
});

const ManageOOPResourcesIndex = ({
                                   history,
                                   counterOrganizations,
                                   counterResources,
                                   counterPersons,
                                   counterUsers,
                                   counterPrograms,
                                   counterSites,
                                   counterReferences,
                                   counterSkills,
                                   counterOrganizationsQuery,
                                   counterResourcesQuery,
                                   counterPersonsQuery,
                                   counterUsersQuery,
                                   counterProgramsQuery,
                                   counterSitesQuery,
                                   counterReferencesQuery,
                                   counterSkillsQuery
                                 }) => {

  const classes = useStyles();

  const handleClick = (link) => {
    history.push(link);
  };

  useEffect(() => {
    counterOrganizationsQuery();
  }, [counterOrganizationsQuery]);

  useEffect(() => {
    counterResourcesQuery();
  }, [counterResourcesQuery]);

  useEffect(() => {
    counterPersonsQuery();
  }, [counterPersonsQuery]);

  useEffect(() => {
    counterUsersQuery();
  }, [counterUsersQuery]);

  useEffect(() => {
    counterProgramsQuery();
  }, [counterProgramsQuery]);

  useEffect(() => {
    counterSitesQuery();
  }, [counterSitesQuery]);


  useEffect(() => {
    counterReferencesQuery();
  }, [counterReferencesQuery]);

  useEffect(() => {
    counterSkillsQuery();
  }, [counterSkillsQuery]);

  return (
    <div>
      <Breadcrumbs items={items}/>
      <div className={classes.root}>
        <Grid container spacing={0} justify="flex-start" alignItems="flex-start">
          {counterOrganizations && <Grid item xs={12} sm={6} md={4} xl={3}>
            <CountersCard
              data={counterOrganizations}
              onClick={handleClick}
              goTo={'/work/app/manage/resources/org'}
            />
          </Grid>}
          {counterResources && <Grid item xs={12} sm={6} md={4} xl={3}>
            <CountersCard
              data={counterResources}
              onClick={handleClick}
              goTo={'/work/app/manage/resources/mattech'}
            />
          </Grid>}
          {counterPersons && <Grid item xs={12} sm={6} md={4} xl={3}>
            <CountersCard
              data={counterPersons}
              onClick={handleClick}
              goTo={'/work/app/person'}
            />
          </Grid>}
          {counterPrograms && <Grid item xs={12} sm={6} md={4} xl={3}>
            <CountersCard
              data={counterPrograms}
              onClick={handleClick}
              goTo={'/work/app/manage/resources/programs'}
            />
          </Grid>}
          {counterSites && <Grid item xs={12} sm={6} md={4} xl={3}>
            <CountersCard
              data={counterSites}
              onClick={handleClick}
              goTo={'/work/app/site'}
            />
          </Grid>}
          {counterReferences && <Grid item xs={12} sm={6} md={4} xl={3}>
            <CountersCard
              data={counterReferences}
              onClick={handleClick}
              goTo={'/work/app/reference'}
            />
          </Grid>}
          {counterSkills && <Grid item xs={12} sm={6} md={4} xl={3}>
            <CountersCard
              data={counterSkills}
              onClick={handleClick}
              goTo={'/work/app/manage/resources/competfgos'}
            />
          </Grid>}
          {counterUsers && <Grid item xs={12} sm={6} md={4} xl={3}>
            <CountersCard
              data={counterUsers}
              onClick={handleClick}
              goTo={'/work/app/manage/resources/users'}
            />
          </Grid>}
        </Grid>
      </div>
    </div>
  )
};

const mapStateToProps = state => ({
  counterOrganizations: state.manageOOPResourcesIndex.counterOrganizations,
  counterResources: state.manageOOPResourcesIndex.counterResources,
  counterPersons: state.manageOOPResourcesIndex.counterPersons,
  counterUsers: state.manageOOPResourcesIndex.counterUsers,
  counterPrograms: state.manageOOPResourcesIndex.counterPrograms,
  counterSites: state.manageOOPResourcesIndex.counterSites,
  counterReferences: state.manageOOPResourcesIndex.counterReferences,
  counterSkills: state.manageOOPResourcesIndex.counterSkills
});

const mapDispatchToProps = dispatch => ({
  counterOrganizationsQuery: () => dispatch(counterOrganizationsQuery()),
  counterResourcesQuery: () => dispatch(counterResourcesQuery()),
  counterPersonsQuery: () => dispatch(counterPersonsQuery()),
  counterUsersQuery: () => dispatch(counterUsersQuery()),
  counterProgramsQuery: () => dispatch(counterProgramsQuery()),
  counterSitesQuery: () => dispatch(counterSitesQuery()),
  counterReferencesQuery: () => dispatch(counterReferencesQuery()),
  counterSkillsQuery: () => dispatch(counterSkillsQuery())
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ManageOOPResourcesIndex));
